<template>
	<div class="animated fadeIn">
		<b-tabs v-model="activeTab">
			<b-tab title="Информация">
				<div class="card">
					<div class="card-header">Мероприятие: <strong>{{ data.title }}</strong>
						<!-- <a class="btn btn-sm btn-info float-right" href="#"><i class="fa fa-edit"></i> редактировать</a> -->
					</div>
					<div class="card-body">
						<div class="row">
							<div class="col-sm-6">
								<dl>
									<dt>Заголовок:</dt>
									<dd>{{ data.title }}</dd>
									<dt>Описание:</dt>
									<dd>{{ data.description }}</dd>
								</dl>
							</div>
						</div>
					</div>
				</div>
			</b-tab>
			<b-tab title="Участники"></b-tab>
		</b-tabs>
	</div>
</template>
<script>
export default {
	data () {
		return {
			loading: false,
			id: null,
			activeTab: 0,
			tabs: {
				0: 'view',
				1: 'members'
			}
		}
	},
	props: {
		data: {
			type: Object,
			default: null
		}
	},
	created () {
		this.id = parseInt(this.$route.params.id)
		this.setTitle()
	},
	methods: {
		setTitle () {
			document.title = 'Информация' + ' | ' + this.data.title
		}
	},
	watch: {
		activeTab: function (value) {
			this.$router.push({path: '/online/' + this.id + '/' + this.tabs[value]})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/online/viewTabs/index.vue